import { companySchema, type CompanyList } from '@jaf/contracts';
import { queryOptions } from '@tanstack/react-query';
import { fetchAllPages } from '@/shared/api';

/** Carrega todas as empresas permitidas para seletores de empresa e escopo. */
export function companyOptionsQuery(organizationId: string) {
  return queryOptions({
    queryKey: ['organizations', organizationId, 'companies', 'options'] as const,
    queryFn: async ({ signal }): Promise<Pick<CompanyList, 'items'>> => ({
      items: await fetchAllPages(
        '/companies',
        companySchema,
        { sortBy: 'legalName', sortOrder: 'asc' },
        signal,
      ),
    }),
  });
}
